import PropTypes from 'prop-types';
import React from 'react';
import BaseComponent from "../../../gd-components/base-component/base-component";

import Classes from 'classnames';

class Smile extends BaseComponent {

    static propTypes = {
        isSelected: PropTypes.bool.isRequired,
        value: PropTypes.string.isRequired
    };

    constructor(props) {
        super(props);

        this.displayName = 'Smile';
        this.labels = ['','Very poor','Poor','Average','Good', 'Excellent'];
    }

    render() {
        const { isSelected, value } = this.props;

        const classes = Classes('smile',{
            'selected': !!isSelected
        });

        let iconSrc = (isSelected)?value+".svg":value+"-bw.svg";
        iconSrc = "/app/web/skin/common/svg/smiles/" + iconSrc;

        return (
            <div className={classes} onClick={this.props.onClick}>
                <img src={iconSrc} />
                <div className="label">{this.labels[value]}</div>
            </div>
        );
    }
}

module.exports = Smile;